import Marquee from "react-fast-marquee";
import { useLang } from "../../context/LanguageContext";

export default function BrandMarquee() {
  const { lang } = useLang();
  const items = lang === "en"
    ? ["Free Estimates", "Tree Removal", "Landscaping", "Stone Work", "Fire Pits", "Chimneys", "Licensed & Insured"]
    : ["Presupuestos Gratis", "Remoción de Árboles", "Jardinería", "Trabajo en Piedra", "Fogatas", "Chimeneas", "Con Licencia"];

  return (
    <section className="border-y border-white/10 bg-acid py-5 overflow-hidden" data-testid="marquee">
      <Marquee speed={55} gradient={false} autoFill>
        {items.map((it, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 font-display uppercase text-2xl md:text-3xl text-obsidian tracking-wide">
            {it}
            <span className="text-obsidian/50 text-xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
